import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  DvButtonComponent,
  DvDialogContent,
  DvDialogContentComponent,
} from '@devinco/ui/dds';
import {
  DvDynamicFormElement,
  DvDynamicFormModule,
  DvFormUtils,
  DvRadioGroupLegacyElement,
  FormOf,
} from '@devinco/ui/legacy';
import { TranslateModule } from '@ngx-translate/core';
import { MapShape } from '@features/map/interfaces';
import { PipesModule } from '@shared/pipes/pipes.module';

@Component({
  imports: [
    DvDynamicFormModule,
    PipesModule,
    DvDialogContentComponent,
    DvButtonComponent,
    TranslateModule,
  ],
  selector: 'app-delete-fleet-location-dialog',
  templateUrl: './delete-fleet-location-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./delete-fleet-location-dialog.component.scss'],
})
export class DeleteFleetLocationDialogComponent
  extends DvDialogContent<MapShape[], DeleteFleetLocationDialogComponent>
  implements OnInit
{
  fleetLocationElements: DvDynamicFormElement[];
  formGroup: FormGroup<FormOf<{ fleetIdToDelete: number | undefined }>>;

  constructor() {
    super();
  }
  ngOnInit(): void {
    this.fleetLocationElements = [
      new DvRadioGroupLegacyElement({
        colspan: 12,
        key: 'fleetIdToDelete',
        direction: 'vertical',
        labelKey: 'label',
        valueKey: 'value',
        items: (this.data as MapShape[]).map(fleetLocation => ({
          value: fleetLocation.id,
          label: fleetLocation.description,
        })),
        gridSize: 1000,
        hintLeft: ' ',
      }),
    ];

    this.formGroup = DvFormUtils.createFormGroup(this.fleetLocationElements);
  }

  cancel(): void {
    this.dialogRef!.onClose(undefined, 'cancel');
  }

  performSave(): void {
    this.dialogRef!.onClose(
      this.formGroup.controls.fleetIdToDelete.value,
      'confirm'
    );
  }
}
